import { useState, type ReactNode } from 'react'

import { Button, Section, SectionHeader } from '../../ui/primitives'
import { Segmented } from '../../ui/fields'
import { THEME_TITLES, useTheme, type ThemeChoice } from '../../state/preferences'
import { useApp } from '../../state/AppState'
import styles from './profile.module.css'

const THEME_OPTIONS: { value: ThemeChoice; title: string }[] = [
  { value: 'system', title: 'Система' },
  { value: 'light', title: 'Светлая' },
  { value: 'dark', title: 'Тёмная' }
]

/**
 * Настройки приложения, а не профиля: тема живёт в браузере и на сервер
 * не уходит. Внизу кабинета, рядом с выходом, — сюда заходят редко, и
 * выше эти строки отодвигали бы от глаз коллекции и сделки.
 */
export function AppSettings(): ReactNode {
  const app = useApp()
  const [theme, setTheme] = useTheme()
  const [isConfirmingExit, setConfirmingExit] = useState(false)

  return (
    <Section>
      <SectionHeader title="Приложение" trailing={THEME_TITLES[theme]} />
      <Segmented
        options={THEME_OPTIONS}
        value={theme}
        onChange={setTheme}
        ariaLabel="Тема оформления"
      />
      <p className={styles.note}>
        Выбор хранится в этом браузере. «Система» — следовать настройке
        оформления в операционной системе.
      </p>

      <div className={styles.actions}>
        {isConfirmingExit ? (
          <>
            {/*
              Подтверждение строкой, а не модальным окном: выход —
              единственное необратимое действие в кабинете, и ради него
              одного заводить слой оверлеев рано.
            */}
            <Button kind="primary" onClick={app.signOut}>
              Точно выйти
            </Button>
            <Button onClick={() => setConfirmingExit(false)}>
              Отмена
            </Button>
          </>
        ) : (
          <Button onClick={() => setConfirmingExit(true)}>Выйти</Button>
        )}
      </div>
    </Section>
  )
}
